import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './auth/ThemeContext'
import { AuthProvider } from './auth/AuthContext'
import './index.css'
import LoginPage from './pages/LoginPage'
import JoinPage from './pages/JoinPage'
import EmployeeSessionPage from './pages/EmployeeSessionPage'
import ProtectedRoute from './components/ProtectedRoute'
import { lazyPage } from './lib/lazyPage'

// Everything below loads on demand — the chat page never downloads admin code.
const ForgotPasswordPage = lazyPage(() => import('./pages/ForgotPasswordPage'))
const ResetPasswordPage  = lazyPage(() => import('./pages/ResetPasswordPage'))
const AdminLayout        = lazyPage(() => import('./pages/admin/AdminLayout'))
const IntegrationsPage   = lazyPage(() => import('./pages/admin/IntegrationsPage'))
const EmployeeStatsPage  = lazyPage(() => import('./pages/admin/EmployeeStatsTab'))
const QuestionsPage      = lazyPage(() => import('./pages/admin/QuestionsPage'))
const EmployeesPage      = lazyPage(() => import('./pages/admin/EmployeesPage'))
const UsersPage          = lazyPage(() => import('./pages/admin/UsersPage'))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
              {/* Operators work in the admin console; chats open only from magic links (/join) */}
              <Route path="/" element={<Navigate to="/admin" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              {/* Employees (magic link) — not operator logins */}
              <Route path="/join" element={<JoinPage />} />
              <Route path="/session" element={<EmployeeSessionPage />} />
              {/* Admin console — every page is its own lazy chunk */}
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
                {/* Statistics is the admin home */}
                <Route index element={<Navigate to="stats" replace />} />
                <Route path="stats" element={<EmployeeStatsPage />} />
                <Route path="stats/employees/:employeeId" element={<EmployeeStatsPage />} />
                <Route path="questions" element={<QuestionsPage />} />
                <Route path="employees" element={<EmployeesPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="integrations" element={<IntegrationsPage />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
)
